export default {"src":"/_next/static/media/ourstory.1024466d.svg","height":411,"width":450};